import './components/index.js';
import './styles/global.css';
import { router } from './shared/router.js';
import { session } from './client/session.js';
import './client/theme.js';

const app = document.getElementById('app')!;

function renderHome(): void {
  const homePage = document.createElement('home-page');
  app.innerHTML = '';
  app.appendChild(homePage);
}

function renderLogin(): void {
  if (session.isAuthenticated()) {
    router.navigate('/dashboard', true);
    return;
  }
  const authForm = document.createElement('auth-form');
  app.innerHTML = '';
  app.appendChild(authForm);
}

function renderDashboard(): void {
  if (!session.isAuthenticated()) {
    router.navigate('/login', true);
    return;
  }
  const dashboard = document.createElement('app-dashboard');
  app.innerHTML = '';
  app.appendChild(dashboard);
}

function renderLandingPage(params: Record<string, string>): void {
  const landingPage = document.createElement('landing-page');
  landingPage.setAttribute('slug', params.slug);
  app.innerHTML = '';
  app.appendChild(landingPage);
}

function renderPurchasePage(): void {
  const purchasePage = document.createElement('purchase-page');
  app.innerHTML = '';
  app.appendChild(purchasePage);
}

function renderVerifyEmail(): void {
  const verifyPage = document.createElement('verify-email-page');
  app.innerHTML = '';
  app.appendChild(verifyPage);
}

function renderForgotPassword(): void {
  const page = document.createElement('forgot-password');
  app.innerHTML = '';
  app.appendChild(page);
}

function renderResetPassword(): void {
  const page = document.createElement('reset-password');
  app.innerHTML = '';
  app.appendChild(page);
}

function renderNotFound(): void {
  const Page404 = document.createElement('page-404');
  app.innerHTML = '';
  app.appendChild(Page404);
}

router.add('/', () => renderHome());
router.add('/login', () => renderLogin());
router.add('/signup', () => renderLogin());
router.add('/dashboard', () => renderDashboard());
router.add('/u/:slug', (params) => renderLandingPage(params));
router.add('/u/:slug/*', (params) => renderLandingPage(params));
router.add('/verify-email', () => renderVerifyEmail());
router.add('/forgot-password', () => renderForgotPassword());
router.add('/reset-password', () => renderResetPassword());
router.add('/purchase', () => renderPurchasePage());
router.notFound(() => renderNotFound());

async function init(): Promise<void> {
  app.innerHTML = '<div style="text-align: center; padding: 2rem;">Loading...</div>';

  await session.init();

  let wasAuthenticated = session.isAuthenticated();
  session.subscribe(() => {
    const isAuthenticated = session.isAuthenticated();
    if (isAuthenticated !== wasAuthenticated) {
      wasAuthenticated = isAuthenticated;
      router.resolve();
    }
  });

  router.start();

  const toastContainer = document.createElement('toast-container');
  document.body.appendChild(toastContainer);
}

init();
